import { getGlossaryLanguage } from './DataUtil';

let host = 'https://087-YZJ-646.mktorest.com';

export function handleFocus(fields, glossary, lang) {
  const elementIds = [
    '#KR_Partner_Solution_Required__c',
    '#Power_Range__c',
    '#Racks_Required__c',
    '#Cloud_Service_Connectivity__c',
    '#Preferred_location__c',
    '#Renewal__c',
    '#KR_Partner_Type__c',
    '#Company_HQ_Country__c',
    '#KR_Partner_Lead_Primary_Contact__c',
    '#Industry',
    '.mktoHtmlText',
    '#Country',
    '#Status_Comments__c',
  ];

  elementIds.forEach((id) => {
    const element = document.querySelector(id);
    if (element) {
      const elementsToTranslate =
        id === '#Country'
          ? [element.options?.[0]]
          : id === '.mktoHtmlText'
            ? [element]
            : element.options || [element];

      translateElements(elementsToTranslate, glossary, lang);
    }
  });

  if (fields) {
    for (let items of fields) {
      for (const field of items) {
        field.addEventListener('focus', function (event) {
          const mktoError = document.querySelector('.mktoInvalid');
          const mktoErrorMsg = document.querySelectorAll('.mktoErrorMsg');
          const mktoRequiredLabel =
            document.querySelector('.mktoRequiredLabel');
          let nextElement = field.nextElementSibling;
          let nextOfNextElement = nextElement.nextElementSibling;
          if (mktoError) {
            translateElements(mktoErrorMsg, glossary, lang);
            // mktoError.classList.add('removeError');
          }

          if (event.target.type === 'email') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(event.target.value.trim())) {
              if (nextOfNextElement.className == 'mktoInstruction') {
                nextOfNextElement.style.cssText += 'display: none !important;';
              }
            } else {
              nextOfNextElement.style.cssText =
                nextOfNextElement.style.cssText.replace(
                  'display: none !important;',
                  ''
                );
            }
          }

          // if(mktoRequiredLabel){
          //     mktoRequiredLabel.style.display = 'none';
          // }

          event.stopPropagation();
          activeClass(event, fields);
        });

        field.addEventListener('keydown', function (event) {
          event.stopPropagation();

          if (!event.shiftKey) {
            activeClass(event, fields);

            const element = document.getElementById('Email');
            const count = element?.value?.length;

            if (count > 0) {
              const mktoError = document.querySelector('.mktoError');

              if (mktoError) {
                mktoError.style.display = 'none';
              }
            }
          }
        });

        field.addEventListener('focusout', function (event) {
          event.stopPropagation();
          removeActiveClass(fields);
          const mktoError = document.querySelector('.mktoInvalid');
          let nextElement = field.nextElementSibling;
          let nextOfNextElement = nextElement.nextElementSibling;
          let element = event.target;
          const parentElement = element.closest('.mktoFormCol');
          const mktoValid = document.querySelector('.mktoValid');
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (
            (event.target?.value?.length === 0 &&
              event.target?.classList.contains('mktoRequired')) ||
            (mktoError && field.id === 'custom-dropdown')
          ) {
            event.target.classList.add('error');
            const mktoError = document.querySelector('.mktoInvalid');

            if (mktoError && mktoError && field.id !== 'custom-dropdown') {
              // mktoError.classList.add('removeError');
              parentElement.classList.add('removeError');
            }
            if (mktoValid) {
              mktoValid.classList.remove('mktoFilled');
              parentElement.classList.remove('mktoFilled');
            }
          } else if (event.target.type === 'email') {
            if (!emailPattern.test(event.target.value.trim())) {
              event.target.classList.add('error');
              parentElement.classList.add('removeError');
              parentElement.classList.remove('mktoFilled');

              if (nextOfNextElement.className == 'mktoInstruction') {
                nextOfNextElement.style.cssText += 'display: none !important;';
              }
            } else {
              event.target.classList.remove('error');
              parentElement.classList.remove('removeError');
              parentElement.classList.add('mktoFilled');
              nextOfNextElement.style.cssText =
                nextOfNextElement.style.cssText.replace(
                  'display: none !important;',
                  ''
                );
            }
          } else if (event.target.type === 'tel') {
            const phonePattern = /^\+?[0-9\s\-()]+$/;
            if (!phonePattern.test(event.target.value.trim())) {
              event.target.classList.add('error');
              parentElement.classList.add('removeError');
              parentElement.classList.remove('mktoFilled');
            } else {
              event.target.classList.remove('error');
              parentElement.classList.remove('removeError');
              parentElement.classList.add('mktoFilled');
            }
          } else {
            event.target.classList.remove('error');
            parentElement.classList.remove('removeError');

            if (mktoValid && event.target.type != 'checkbox') {
              mktoValid.classList.add('mktoFilled');
              parentElement.classList.add('mktoFilled');
            } else {
              mktoValid.classList.remove('mktoFilled');
              parentElement.classList.remove('mktoFilled');
            }
          }
          if (field.id == 'temporaryField2' && event.target.value == '') {
            field.classList.remove('error');
            parentElement.classList.remove('removeError');
          }
          // if (field.id == 'formComments' && event.target.value == '') {
          //   field.classList.remove('error');
          //   console.log("removing form comments");
          //   parentElement.classList.remove('removeError');
          // }
        });
      }
    }
  }
}

export function removeActiveClass(fields) {
  const button = document.querySelector('.marketo-form button');

  if (fields) {
    for (const items of fields) {
      for (const item of items) {
        if (item.id == 'Preferred_location__c') {
          return;
        }
        const elem = item.parentElement.firstChild;

        if (
          item?.value?.length === 0 &&
          button !== document.activeElement &&
          item?.type !== 'select-one'
        ) {
          elem.classList.remove('active');
        }
      }
    }
  }
}

export function activeClass(event, fields) {
  removeActiveClass(fields);

  let prevSibling = event.target.previousElementSibling?.previousElementSibling;

  if (prevSibling?.nodeName === 'LABEL') {
    prevSibling.classList.add('active');
  }
}

export function autoPopulateAddActive(fields) {
  for (let items of fields) {
    for (const field of items) {
      if (field.labels !== null) {
        field.labels?.[0]?.classList.add('active');
        let prevSibling = field.previousElementSibling?.previousElementSibling;

        if (prevSibling?.nodeName === 'LABEL') {
          prevSibling.classList.add('active');
        }
      }
    }
  }
}

export function autoPopulateAddFilled(fields) {
  if (!fields) {
    return;
  }

  for (const items of fields) {
    for (const field of items) {
      if (field.type === 'checkbox' || field.type === 'radio') {
        continue;
      }

      const parentElement = field.closest?.('.mktoFormCol');

      if (parentElement && field.value?.length > 0) {
        parentElement.classList.add('mktoFilled');
        parentElement.classList.remove('removeError');
      }
    }
  }
}

export function autoPopulateAddActiveForStatusComment(fields) {
  for (let items of fields) {
    for (const field of items) {
      if (field.name == 'Preferred_location__c') {
        if (field.labels !== null) {
          field.labels?.[0]?.classList.add('active');
          let prevSibling =
            field.previousElementSibling?.previousElementSibling;

          if (prevSibling?.nodeName === 'LABEL') {
            prevSibling.classList.add('active');
          }
        }
      }
    }
  }
}

export function translateElements(data, glossary, lang) {
  if (!glossary || glossary.length === 0) {
    return;
  }

  function normalizeAndCompare(str1, str2) {
    // Replace various whitespace characters with regular spaces
    const normalizedStr1 = str1?.replace(/\s+/g, ' ').trim().toLowerCase();
    const normalizedStr2 = str2?.replace(/\s+/g, ' ').trim().toLowerCase();

    // Handle special characters and punctuation
    const cleanStr1 = normalizedStr1?.replace(/[^\w\s]/g, '');
    const cleanStr2 = normalizedStr2?.replace(/[^\w\s]/g, '');

    // Use locale-specific comparison for better Unicode support
    return cleanStr1.localeCompare(cleanStr2) === 0;
  }

  for (let item of data) {
    // Fall back to textContent for hidden elements (e.g. the native <select>
    // options that Marketo replaces with a custom dropdown): innerText is empty
    // for display:none nodes, so without this their text is never matched.
    let innerText = item?.innerText || item?.textContent;

    for (let word of glossary) {
      if (normalizeAndCompare(word['en'], innerText)) {
        item.innerHTML = word[getGlossaryLanguage(lang)];
        break; // Exit the loop once a match is found
      }
    }
  }
}

// Translate rich-text blocks (e.g. `.mktoHtmlText` and its <strong> heading
// like "Information about your project:"). Unlike translateElements, this
// strips HTML tags before comparing, so it matches whether the glossary stores
// the `en` value as plain text OR as HTML markup (translateElements leaves the
// tag letters — e.g. "strong" — in the normalized string, so a markup-based
// glossary entry never matches). The translated value is written as innerHTML
// so any markup (bold) in the glossary value is preserved.
export function translateHtmlText(nodes, glossary, lang) {
  if (!glossary || glossary.length === 0 || !nodes) {
    return;
  }

  const target = getGlossaryLanguage(lang);

  // Strip tags, collapse whitespace, drop punctuation, lowercase.
  const toPlain = (str) =>
    (str || '')
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .replace(/[^\w\s]/g, '')
      .trim()
      .toLowerCase();

  for (const node of nodes) {
    if (!node) continue;

    const nodePlain = toPlain(node.innerText || node.textContent);
    if (!nodePlain) continue;

    for (const word of glossary) {
      if (!word?.en || !word[target]) continue;

      if (toPlain(word.en) === nodePlain) {
        node.innerHTML = word[target];
        break;
      }
    }
  }
}

export function translateRecaptcha(data, glossary, lang) {
  if (!glossary || glossary.length === 0) {
    return;
  }

  // Ensure data and innerHTML are defined
  const innerHtml = data?.innerHTML;

  if (!innerHtml) {
    console.error('data.innerHTML is undefined');
    return; // Exit if innerHTML is not available
  }

  // Define normalizeWhitespace function outside the loop
  const normalizeWhitespace = (str) => str.replace(/\s+/g, ' ').trim();

  for (let word of glossary) {
    // Ensure word.en is defined
    if (word.en) {
      if (normalizeWhitespace(word.en) === normalizeWhitespace(innerHtml)) {
        // Check if the language property exists
        const translation = word[getGlossaryLanguage(lang)];
        if (translation) {
          data.innerHTML = translation;
        } else {
          console.error(
            `Translation for language ${lang} not found in glossary.`
          );
        }
        break; // Exit the loop once a match is found
      }
    } else {
      console.warn('word.en is undefined for a glossary entry:', word);
    }
  }
}

export function translatePlaceholders(inputs, glossary, lang) {
  if (!glossary || glossary.length === 0) {
    return;
  }

  function normalizeAndCompare(str1, str2) {
    const normalizedStr1 = str1?.replace(/\s+/g, ' ').trim().toLowerCase();
    const normalizedStr2 = str2?.replace(/\s+/g, ' ').trim().toLowerCase();
    const cleanStr1 = normalizedStr1?.replace(/[^\w\s]/g, '');
    const cleanStr2 = normalizedStr2?.replace(/[^\w\s]/g, '');

    return cleanStr1.localeCompare(cleanStr2) === 0;
  }

  inputs.forEach((input) => {
    let placeholderText = input?.getAttribute('placeholder');

    for (let word of glossary) {
      if (normalizeAndCompare(word['en'], placeholderText)) {
        input.setAttribute('placeholder', word[getGlossaryLanguage(lang)]);
        break;
      }
    }
  });
}

// Translates the `title` attribute (tooltip) of fields/inputs from the glossary.
// Marketo puts field instructions in the `title` attribute (and in an adjacent
// .mktoInstruction span), neither of which the label/placeholder passes cover.
export function translateTitles(inputs, glossary, lang) {
  if (!glossary || glossary.length === 0) {
    return;
  }

  function normalizeAndCompare(str1, str2) {
    const normalizedStr1 = str1?.replace(/\s+/g, ' ').trim().toLowerCase();
    const normalizedStr2 = str2?.replace(/\s+/g, ' ').trim().toLowerCase();
    const cleanStr1 = normalizedStr1?.replace(/[^\w\s]/g, '');
    const cleanStr2 = normalizedStr2?.replace(/[^\w\s]/g, '');

    return cleanStr1?.localeCompare(cleanStr2) === 0;
  }

  inputs.forEach((input) => {
    let titleText = input?.getAttribute('title');
    if (!titleText) {
      return;
    }
    for (let word of glossary) {
      if (normalizeAndCompare(word['en'], titleText)) {
        input.setAttribute('title', word[getGlossaryLanguage(lang)]);
        break;
      }
    }
  });
}

const validateForm = (fields) => {
  const missingFields = [];

  Array.from(fields).forEach((field) => {
    if (!field.value?.trim()) {
      if (field.name) {
        missingFields.push(field.name);
      }
    }
  });

  if (missingFields.length > 0) {
    console.log(`Missing fields: ${missingFields.join(', ')}`);
    return false;
  }

  return true;
};

export function handleChange(formId, event) {
  // Ove forme imaju poseban modal validation flow – ovde ih skipujemo
  const modalForms = [
    '2788',
    '2786',
    '2801',
    '3134',
    '3148',
    '3203',
    '3276',
    '3278',
  ];
  if (modalForms.includes(String(formId))) {
    return;
  }

  const buttons = document.querySelectorAll('#mktoForm_' + formId + ' button');
  const fields = document.querySelectorAll(
    '#mktoForm_' + formId + ' .mktoRequired'
  );
  const fields2 = document.querySelectorAll(
    '#mktoForm_' + formId + ' .mktoRequiredField'
  );
  let combinedFields = [...fields, ...fields2];

  if (formId === '2801') {
    combinedFields = combinedFields.filter(
      (field) =>
        // field.id !== 'formComments' &&
        field.id !== 'temporaryField2'
    );
  }

  const isValid = validateForm(combinedFields);

  if (isValid) {
    buttons[0]?.classList.toggle('active', isValid);
    buttons[0]?.classList.toggle('enable', isValid);
  } else {
    buttons[0]?.classList.toggle('disable', false);
    buttons[0]?.classList.remove('active');
    buttons[0]?.classList.remove('enable');
  }
}

export function handleChangeRegisterLead(formId) {
  const buttons = document.querySelectorAll('#mktoForm_' + formId + ' button');
  const fields = document.querySelectorAll(
    '#mktoForm_' + formId + ' .mktoRequired'
  );
  const fields2 = document.querySelectorAll(
    '#mktoForm_' + formId + ' .mktoRequiredField'
  );
  const combinedFields = [...fields, ...fields2];
  const isValid = validateForm(combinedFields);
  const form = window.MktoForms2?.getForm(formId);
  const formValues = form.vals();

  if (isValid && formValues.Pref_Optin_Pending__c === 'yes') {
    // generateCaptchaToken();
    buttons[0]?.classList.toggle('active', isValid);
    buttons[0]?.classList.toggle('enable', isValid);
    // buttons[0].addEventListener('click', function () {
    //   this.disabled = true;
    // });
  } else {
    buttons[0]?.classList.remove('enable');
    buttons[0]?.classList.remove('active');
  }
}

export function handleChangeModal(formId, event) {
  const buttons = document.querySelectorAll('#mktoForm_' + formId + ' button');
  let areCustomDropDownsFilled = false;
  const form = window.MktoForms2?.getForm(formId);
  // console.log(form.vals());
  const formVals = form.vals();
  if (
    formId == '3148' ||
    formId == '3147' ||
    formId == '2788' ||
    formId == '2787' ||
    formId == '3278' ||
    formId == '3203' ||
    formId == '3276'
  ) {
    delete formVals.Power_Range__c;
  }

  const requiredFields = [];

  const requiresState =
    ['2788', '2786', '2801', '3134', '3148', '3203'].includes(String(formId)) &&
    formVals.Country === 'United States';

  if (requiresState) {
    requiredFields.push('State');
  }

  if (
    validateFormWithChecks(
      formVals,
      [
        'honeyPotSubmission',
        'utm_li_fat_id_most_recent__c',
        'utm_gclid_most_recent__c',
        'utm_gbraid_most_recent__c',
        'utm_wbraid_most_recent__c',
        '_ga',
        'cookiegamostrecent',
        'UTM_Campaign__c',
        'UTM_Content__c',
        'UTM_Medium__c',
        'UTM_Source__c',
        formId === '2786' ? 'Industry' : null,
        formId == '2787' || formId == '3276' ? 'formComments' : null,
        formId == '2801' ? 'temporaryField2' : null,
        formId == '2801' ? 'Company' : null,
      ],
      requiredFields
    )
  ) {
    areCustomDropDownsFilled = true;
  } else {
    areCustomDropDownsFilled = false;
  }

  setTimeout(() => {
    if (areCustomDropDownsFilled) {
      buttons[0]?.classList.toggle('enable', areCustomDropDownsFilled);
      buttons[0]?.classList.add('active');
    } else {
      buttons[0]?.classList.remove('active');
      buttons[0]?.classList.remove('enable');
    }
  }, 100);
}

export function enableMarketoButton(formId, event, checked) {
  const buttons = document.querySelectorAll('#mktoForm_' + formId + ' button');
  buttons[0]?.classList.toggle('enable', checked);
  if (checked) {
    buttons[0]?.classList.add('active');
  } else {
    buttons[0]?.classList?.remove('active');
  }
}

export const validateFormWithChecks = (
  data,
  ignoreKeys = [],
  requiredKeys = []
) => {
  for (const key in data) {
    if (requiredKeys.includes(key) && !data[key]) {
      console.log(`Required key is missing or empty: ${key}`);
      return false;
    }
    if (!ignoreKeys.includes(key) && !data[key]) {
      console.log(`Missing value for key: ${key}`);
      return false;
    }
  }
  return true;
};

export const validateFormWithChecksCookie = (
  data,
  ignoreKeys = [],
  requiredFields = {}
) => {
  for (const key in requiredFields) {
    if (ignoreKeys.includes(key)) {
      console.log(`Ignoring key: ${key}`);
      continue;
    }

    if (
      !data.hasOwnProperty(key) ||
      data[key] === null ||
      data[key] === undefined ||
      data[key] === ''
    ) {
      console.log(`Missing or empty required field: ${key}`);
      return false;
    }
  }

  for (const key in data) {
    if (
      !ignoreKeys.includes(key) &&
      (data[key] === null || data[key] === undefined || data[key] === '')
    ) {
      console.log(`Invalid value for key: ${key}`);
      return false;
    }
  }

  return true;
};

export const generateCaptchaToken = () => {
  let allForms = window.MktoForms2.allForms();

  if (allForms.length > 1) {
    const secondForm = allForms[1]; // Get the second form

    // Remove the form's element from the DOM if it exists
    const secondFormEl = document.getElementById(secondForm.getId());
    if (secondFormEl) {
      secondFormEl.remove();
    }

    // Create a new array excluding the second form (index 1)
    const newFormsArray = allForms.slice(0, 1).concat(allForms.slice(2));

    // Override the MktoForms2.allForms() to return the updated array
    window.MktoForms2.allForms = () => newFormsArray;
  } else {
    delete window.MktoForms2;
  }
  if (window.MktoForms2) {
    const firstForm = window.MktoForms2.allForms()[0];

    if (firstForm) {
      const captchaElement = firstForm.getFormElem().find('.g-recaptcha');

      if (captchaElement) {
        grecaptcha
          .execute(captchaElement.data('widget-id'))
          .then((token) => {
            firstForm.addHiddenFields({ captchaToken: token });

            console.log('Token generisan i dodat u formu.');
          })
          .catch((error) => {
            console.error('Greška prilikom izvršavanja reCAPTCHA:', error);
          });
      }
    }
  }
};

export const mergePrivacyAndCaptchaText = (formId) => {
  let privacyElement = document.querySelector('.mktoHtmlText.mktoHasWidth');

  if (formId && formId === '3203') {
    privacyElement = document.querySelector(
      '.mktoHtmlText.mktoHasWidth:has(a[href])'
    );
  }
  const captchaElement = document.querySelector('.mktoCaptchaDisclaimer');

  if (privacyElement && captchaElement) {
    const privacyHTML = privacyElement.innerHTML.trim();
    const captchaText = captchaElement.innerHTML.trim();

    const mergedHTML = `${privacyHTML} ${captchaText}`;

    privacyElement.innerHTML = mergedHTML;

    privacyElement.classList.add('merged-privacy-text');
    captchaElement.style.display = 'none';
  }
};

export function setupMktoSubmitWatcher({ formId, formUrl, onFail, onDone }) {
  let pending = false;
  let watchdog = null;

  const allowedOrigin = (() => {
    try {
      const httpOrigin = new URL(`http://${formUrl}`).origin;
      const httpsOrigin = new URL(`https://${formUrl}`).origin;
      return [httpOrigin, httpsOrigin];
    } catch {
      return ['*'];
    }
  })();

  function clear() {
    pending = false;
    if (watchdog) {
      clearTimeout(watchdog);
      watchdog = null;
    }
  }

  function handleMessage(e) {
    try {
      if (allowedOrigin[0] !== '*' && !allowedOrigin.includes(e.origin)) return;
      const msg = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      const res = msg?.mktoResponse;
      // console.log("res", res);
      if (!res) return;
      if (res.error == true) {
        clear();
        onFail?.(res.message || 'Submission failed. Please try again.');
      } else {
        clear();
        onDone?.();
      }
    } catch (_) {
      /* noop */
    }
  }

  // Pozivaš kad krene submit
  function arm() {
    pending = true;
    // Fallback: ako u X sekundi ne dobijemo ništa – tretiraj kao fail mreže
    watchdog = setTimeout(() => {
      if (pending) {
        clear();
        onFail?.('Network issue while submitting the form.');
      }
    }, 15000); // 15s watchdog
  }

  window.addEventListener('message', handleMessage);
  return {
    arm,
    dispose: () => window.removeEventListener('message', handleMessage),
  };
}
